import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import socialReducer from './socialSlice';
import blogReducer from "./blogSlice";
import seoReducer from "./seoSlice";


import notificationsReducer from "./notificationsSlice";
import threadsReducer from "./threadsSlice";
import supportReducer from "./supportSlice"; 

import commercePartnersReducer from "./commercePartnersSlice";

import classifiedsReducer from "./classifiedsSlice";
import classifiedOrdersReducer from "./classifiedOrdersSlice";
import classifiedCommerceServiceFeeReducer from "./classifiedCommerceServiceFeeSlice";
import classifiedRatingReducer from "./classifiedRatingSlice";

import cartReducer from "./cartSlice";
import productsReducer from "./productSlice";
import productRatingsReducer from "./productRatingSlice";
import productOrdersReducer from "./productOrdersSlice";

import payoutMethodReducer from "./payoutMethodSlice";
import payoutsReducer from "./payoutsSlice";
import paymentMethodsReducer from "./paymentMethodSlice";
import revenueReducer from "./revenueSlice";






export const store = configureStore({
  reducer: {
    auth: authReducer,
    commercePartners: commercePartnersReducer,

    social: socialReducer, 
  support: supportReducer,
  threads: threadsReducer,

    blog: blogReducer,
      seo: seoReducer,



      cart: cartReducer,
products: productsReducer,
productOrders: productOrdersReducer,
productRatings: productRatingsReducer,


      classifieds: classifiedsReducer,
    classifiedOrders: classifiedOrdersReducer,
    classifiedCommerceServiceFees: classifiedCommerceServiceFeeReducer, // ✅ NEW
    classifiedRatings: classifiedRatingReducer,
    notifications: notificationsReducer,


    revenue: revenueReducer,
     payouts: payoutsReducer,
     payoutMethod: payoutMethodReducer,
paymentMethods: paymentMethodsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
